import { useQuery } from '@apollo/client/react';
import React, { useState } from 'react';
import '../EditEquipmentDetails.scss';
import { Table } from 'react-bootstrap';
import { Loading } from '../../../../_common';
import { DropdownOption } from '../../../../_common/SearchableDropdown/SearchableDropdown';
import { GET_ALL_EQUIPMENT_TYPES } from '../../../../../graphql/client/queries';
import EquipmentDetailsEditRow from './EquipmentsDetailsEditRow';
import {
    GetAssetInfoByLoadId_getAssetInfoByLoadId as AssetInfoType,
    GetAllEquipmentTypes,
    GetEquipmentsInfo_getEquipmentsInfo as EquipmentsInfo,
} from '../../../../../types/schemaTypes';
import { PermissionEnum } from '../../../../../types/PermissionEnum';
import { useAuthContext } from '../../../../Auth/AuthProvider/AuthProvider';

interface AssetInfoToSaveProps {
    index: number;
    assetTypeId: number | null;
    assetType: string | null;
    assetId: number | null;
    assetDescrip: string | null;
    quantity: number | null;
}

interface EquipmentDetailsEditProps {
    assetStatus: string;
    assetInfo: AssetInfoType[];
    assetInfoToSave: AssetInfoToSaveProps[] | undefined;
    setAssetInfoToSave: React.Dispatch<React.SetStateAction<AssetInfoToSaveProps[] | undefined>>;
    equipmentsInfo: EquipmentsInfo | undefined;
    updatePaycode: () => void;
    infoLoading: boolean;
}

const EquipmentDetailsEdit = ({
    assetStatus,
    assetInfo,
    assetInfoToSave,
    setAssetInfoToSave,
    equipmentsInfo,
    updatePaycode,
    infoLoading,
}: EquipmentDetailsEditProps): React.ReactElement => {
    const canEditAssets = useAuthContext().userHasPermission(PermissionEnum.EditAssets);

    const [rowCount, setRowCount] = useState(assetInfo.length);

    const asssetTypes: DropdownOption[] = [];
    const { data, loading } = useQuery<GetAllEquipmentTypes>(GET_ALL_EQUIPMENT_TYPES);
    if (data && data.getAllEquipmentTypes) {
        let isMatsSelected = false;
        let isForkliftRampsSelected = false;
        let isMiscellaneousSelected = false;
        assetInfoToSave?.map(assetInfo => {
            if (assetInfo.assetType === "Mats") isMatsSelected = true;
            if (assetInfo.assetType === "Forklift Ramp") isForkliftRampsSelected = true;
            if (assetInfo.assetType === "Miscellaneous") isMiscellaneousSelected = true;
        })
        data.getAllEquipmentTypes.map(item => {
            if (
                item && (
                    (!isMatsSelected || (isMatsSelected && item.name !== "Mats")) &&
                    (!isForkliftRampsSelected || (isForkliftRampsSelected && item.name !== "Forklift Ramp")) &&
                    (!isMiscellaneousSelected || (isMiscellaneousSelected && item.name !== "Miscellaneous"))
                )
            )
                asssetTypes.push(item)
        })
    }

    const handleOnClickAddEquipment = () => {
        if (!["Created", "ReadyForDispatch", "Assigned"].includes(assetStatus)) return;
        setRowCount(rowCount + 1);
    };

    const renderEquipmentsDetailsRow = () => {
        const EquipmentsDetailsRows: React.ReactElement[] = assetInfo.map((info, index) => (
            <EquipmentDetailsEditRow
                key={index}
                index={index}
                asset={info}
                assetInfoToSave={assetInfoToSave}
                setAssetInfoToSave={setAssetInfoToSave}
                asssetTypes={asssetTypes}
                equipmentsInfo={equipmentsInfo}
                updatePaycode={updatePaycode}
                loading={infoLoading}
                isEditable={canEditAssets && ["Created", "ReadyForDispatch", "Assigned"].includes(assetStatus)}
            />
        ))

        for (let i = assetInfo.length; i < rowCount; i++) {
            EquipmentsDetailsRows.push(
                <EquipmentDetailsEditRow
                    key={i}
                    index={i}
                    asset={undefined}
                    assetInfoToSave={assetInfoToSave}
                    setAssetInfoToSave={setAssetInfoToSave}
                    asssetTypes={asssetTypes}
                    equipmentsInfo={equipmentsInfo}
                    updatePaycode={updatePaycode}
                    loading={infoLoading}
                    isEditable={canEditAssets && ["Created", "ReadyForDispatch", "Assigned"].includes(assetStatus)}
                />
            )
        }

        return EquipmentsDetailsRows;
    }

    return (
        <div className='EditEquipmentDetails-Container'>
            <div className='EditEquipmentDetails-Header'>
                Equipment Details
            </div>

            <Table striped bordered className="tabletest EquipmentsDetails EquipmentsDetails-Edit-Grid">
                <thead>
                    <tr>
                        <th>Equipment Type</th>
                        <th>Quantity</th>
                        <th>ID</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ? (
                            <div className="EquipmentProfile-Loading">
                                <Loading />
                            </div>
                        ) : renderEquipmentsDetailsRow()
                    }
                </tbody>
            </Table>

            {
                canEditAssets && (
                    <div className='EditEquipmentDetails-Buttons-Container' onClick={handleOnClickAddEquipment}>
                        <i className="material-icons EditEquipmentDetails-AddEquipment-Icon">add_circle</i>
                        <span className="EditEquipment-AddEquipment-Link">Add Equipment</span>
                    </div>
                )
            }
        </div>
    )
}

export default EquipmentDetailsEdit;

